var UnsubscribeCheckbox = /** @class */ (function () {
    function UnsubscribeCheckbox(checkbox, input) {
        this.input = input;
        this.lineId = parseInt(checkbox.name.replace('form-unsubscribe[][', '').replace(']', ''));
        checkbox.removeAttribute('name');
        checkbox.addEventListener('change', this.onChange.bind(this));
    }
    UnsubscribeCheckbox.prototype.onChange = function () {
        this.input.toggleLine(this.lineId);
    };
    return UnsubscribeCheckbox;
}());
export default UnsubscribeCheckbox;
